import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_NEW_MAIL_SOUND_ENABLED', function (isEnabled) {
    getStore().newMailSound = isEnabled;
});
//# sourceMappingURL=setNewMailSoundEnabled.js.map